import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PersistConfig, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { SIDEBAR_WIDTH } from './navigation.constants';
import { NavigationSidebarItem } from './navigationSidebar.constants';

interface SidebarState {
  isVisible: boolean;
  activeItem: NavigationSidebarItem | null;
  isFullView: boolean;
}

const initialState: SidebarState = {
  isVisible: false,
  activeItem: null,
  isFullView: false,
};

const persistConfig: PersistConfig<SidebarState> = {
  key: 'sidebar',
  storage,
  version: CACHE_STORE_VERSION,
  whitelist: ['activeItem', 'isFullView'],
};

export const navigationSidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setIsVisible: (state, action) => {
      state.isVisible = action.payload;
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    setIsFullView: (state, action: PayloadAction<boolean>) => {
      state.isFullView = action.payload;
    },
    toggleIsFullView: (state) => {
      state.isFullView = !state.isFullView;
    },
  },
  selectors: {
    selectIsFullView: (state) => state.isFullView,
    selectActiveItem: (state) => state.activeItem,
    selectIsVisible: (state) => state.isVisible,
    selectSidebarWidth: (state) =>
      state.isFullView ? SIDEBAR_WIDTH.FULL : SIDEBAR_WIDTH.COMPACT,
  },
});

export const navigationSidebarPersistedReducer = persistReducer(
  persistConfig,
  navigationSidebarSlice.reducer,
);
